import React from "react";
import Accordion from './detalle-accordion';

const Description = ({descripcion, comentarios})=>{
    return <>
        <Accordion title="Descripción del producto" isopen={true}>
            { descripcion && <div dangerouslySetInnerHTML={{__html: descripcion}}/> }
            { comentarios && <div dangerouslySetInnerHTML={{__html: comentarios}}/> }
        </Accordion>
        <Accordion title="Promesa Detalles y Caprichos">
            <ul>
                <li>Nos esforzamos en cada envio, por lo que te garantizamos que será entregado en el horario seleccionado.</li>
                <li>Nuestra calidad es inigualable, solo manejamos materiales premium y flores del día.</li>
                <li>Manejamos una política de sustitución, en caso de que nuestro producto no llegue con la calidad necesaria.</li>
                <li>Lo que ves es lo que compras, jamas cambiamos el color o tipo de flor a excepción que nos lo hayas especificado.</li>
                <li>Todas tus compras pueden ser facturadas</li>
            </ul>
        </Accordion>
        <Accordion title="Politica de envio" margin={true}>
            <ul>
                <li>En promedio nuestros envios salen en 2 horas despues de la confirmación de pago.</li>
                <li>Nuestros envios son programados para que se entreguen en el horario especificado, en casos extraodinarios podrian entregarse minutos despues por causas externas como el trafico y/o accidentes viales.</li>
                <li>Los envios de Lunes a Viernes empiezan a las 9:00 hasta las 19:00 horas y Sabados de 9:00 a 14:00 horas</li>
                <li>Los domingos no hacemos envios, ponte en contacto con nosotros y ver si podemos hacer una excepción.</li>
            </ul>
        </Accordion>
    </>
};

export default Description;